// Web polyfill for react-native-safe-area-context
// Provides web-compatible implementations of SafeAreaProvider and SafeAreaView
import * as React from 'react';
import { View } from 'react-native';

// Initial window metrics - web için default değerler
export const initialWindowMetrics = {
  frame: {
    x: 0,
    y: 0,
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0,
  },
  insets: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
};

// SafeAreaInsetsContext - React Navigation için gerekli Context
export const SafeAreaInsetsContext = React.createContext({
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
});

// SafeAreaFrameContext - Frame bilgisi için Context
export const SafeAreaFrameContext = React.createContext({
  x: 0,
  y: 0,
  width: typeof window !== 'undefined' ? window.innerWidth : 0,
  height: typeof window !== 'undefined' ? window.innerHeight : 0,
});

// SafeAreaProvider - web'de sadece children'ı render eder
export const SafeAreaProvider = ({ children, initialMetrics: customMetrics }) => {
  const metrics = customMetrics || initialWindowMetrics;
  
  return React.createElement(
    SafeAreaInsetsContext.Provider,
    { value: metrics.insets },
    React.createElement(
      SafeAreaFrameContext.Provider,
      { value: metrics.frame },
      children
    )
  );
};

// SafeAreaView - web'de normal View olarak render edilir
export const SafeAreaView = React.forwardRef(({ children, style, edges, ...props }, ref) => {
  // edges prop'u web'de kullanılmaz, sadece style uygulanır
  return React.createElement(View, { style, ref, ...props }, children);
});

// useSafeAreaInsets - web'de tüm değerler 0 döner
export const useSafeAreaInsets = () => {
  const insets = React.useContext(SafeAreaInsetsContext);
  return insets || {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  };
};

// useSafeAreaFrame - web'de window boyutlarını döner
export const useSafeAreaFrame = () => {
  const frame = React.useContext(SafeAreaFrameContext);
  if (frame) return frame;
  
  if (typeof window === 'undefined') {
    return { x: 0, y: 0, width: 0, height: 0 };
  }
  return {
    x: 0,
    y: 0,
    width: window.innerWidth,
    height: window.innerHeight,
  };
};

// Default export
const reactNativeSafeAreaContext = {
  SafeAreaProvider,
  SafeAreaView,
  SafeAreaInsetsContext,
  SafeAreaFrameContext,
  useSafeAreaInsets,
  useSafeAreaFrame,
  initialWindowMetrics,
};

export default reactNativeSafeAreaContext;

